// import axios from 'axios';
// //import Cookies from 'js-cookie';


// const axiosInstance = axios.create({
//   baseURL: process.env.REACT_APP_API_BASE_URL,
//   // timeout: 5000, // Timeout of 5 seconds
//   headers: {
//     'Content-Type': 'application/json',
//   },
// });
// // Add a request interceptor to include the authentication token from cookie in every request
// axiosInstance.interceptors.request.use(
//   (config) => {
//    // const token = Cookies.get('access_token'); // Retrieve token from cookie
//    const token =localStorage.getItem('authToken');
//     console.log('access_token', token);
//     if (token) {
//       config.headers.auth= `${token}`;
//     }
//     return config;
//   },
//   (error) => {
//     return Promise.reject(error);
//   },
// );

// // axiosInstance.interceptors.response.use(
// //   (response) => {
// //     console.log('---------------->>>>, response: ', response);
// //     return response;
// //   },
// //   (error) => {
// //     console.log('---------------->>>>, error: ', error);
// //     if (error.response && error.response.status === 401) {
// //       console.log('Unauthorized error');
// //       // localStorage.clear();
// //       // Cookies.clear();
// //       // Navigate('/login');
// //     }
// //     return Promise.reject(error);
// //   },
// // );

// export default axiosInstance;



import axios from 'axios';

const authToken = localStorage.getItem('authToken');

const axiosInstance = axios.create({
  baseURL: process.env.REACT_APP_API_BASE_URL,
  headers: {
    'Authorization': `Bearer ${authToken}`,
    'Content-Type': 'application/json',
  },
});
 

  export default axiosInstance;


